const getLoggedInUserProfile = state => state.loggedInUserProfile;
const getJoinedStudents = (state) => {
  if (state.usageStatistics && state.usageStatistics.allInvitedStudentCount) {
    return state.usageStatistics.allInvitedStudentCount;
  }
  return 0;
};

const isDktUser = state => (!!state.loggedInUserProfile && state.loggedInUserProfile.provider === 'idp');

const getUserSupportedLanguages = state => state.loggedInUserProfile.supportedLanguages;

export default {
  getLoggedInUserProfile,
  getJoinedStudents,
  isDktUser,
  getUserSupportedLanguages
};



// WEBPACK FOOTER //
// ./src/store/modules/users/getters.js